import Vue from 'vue'
import { VCol, VContainer } from 'vuetify/lib'
import './GenericError.scss'

export const GenericError = Vue.component('GenericError', {
	name: 'GenericError',

	render() {
		return (
			<VContainer class="generic-error-container">
				<VCol>
					<h2>Erro na Aplicação</h2>
					<p>Desculpe, a aplicação falhou ao iniciar. Por favor, atualize a página ou entre em contato com o suporte.</p>
				</VCol>
			</VContainer>
		)
	}
})

export default GenericError
